// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__18ISm","title":"card_title__2Ag2D","inActive":"card_inActive__2HlPy"};